import React, { useRef, useCallback } from 'react'

import classnames from 'classnames/bind'
import css from './styles.module.scss'
const cx = classnames.bind(css)

import useLabelTitleTextAnimation from 'hooks/useLabelTitleTextAnimation'
import useResizeIndex from 'hooks/useResizeIndex'
import useAnimateInView from 'hooks/useAnimateInView'
import useComponentSize from '@rehooks/component-size'

import Image from 'components/shared/Image'
import { Title } from 'components/typo'
import Button from 'components/shared/Button'
import ContactForm from 'components/shared/ContactForm'

const NewIntro = ({ darkMode, button, logo, title, embed, className }) => {
  const componentRef = useRef()
  const elementRef = useRef()
  const imageRef = useRef()
  const titleRef = useRef()
  const buttonRef = useRef()

  const { width, height } = useComponentSize(componentRef)
  const resizeIndex = useResizeIndex()

  const [inViewRef] = useAnimateInView(
    {
      triggerOnce: true,
      ref: componentRef,
      animateIn: () => tl.restart(true),
    },
    [width, height, resizeIndex]
  )

  const tl = useLabelTitleTextAnimation(
    {
      elementRef,
      components: [
        {
          ref: imageRef,
          type: 'zoom',
        },

        {
          key: 'headline',
          ref: titleRef,
          type: 'splitText',
        },
        {
          ref: buttonRef,
          type: 'zoom',
        },
      ],
      linesClass: css.line,
    },
    [width, height, resizeIndex]
  )

  const setRef = useCallback((node) => {
    elementRef.current = node
    inViewRef(node)
  }, [])

  const isLogo = logo && Object.keys(logo.media).length > 0

  return (
    <div ref={componentRef} className={cx(isLogo && css.imagePadding)}>
      <div ref={setRef}>
        <div className={cx(className, css.NewIntro)}>
          {isLogo && (
            <div ref={imageRef}>
              <Image {...logo} className={css.logo} />
            </div>
          )}
          {title && (
            <div ref={titleRef}>
              <Title
                className={css.title}
                theme={darkMode ? 'white' : 'dark'}
                size="medium-extra-large"
              >
                {title}
              </Title>
            </div>
          )}
          {button && (
            <div ref={buttonRef}>
              <Button {...button} className={css.button} />
            </div>
          )}
          {embed && <ContactForm className={css.form} {...embed} />}
        </div>
      </div>
    </div>
  )
}

export default NewIntro
